import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Subscription } from "rxjs";
import { environment } from "../../../../../environments/environment";
import { NotificationsService } from "../../../../services/notifications.service";

@Component({
  selector: 'app-notifications-responsive',
  templateUrl: './notifications-responsive.component.html',
  styleUrl: './notifications-responsive.component.scss',
  standalone: false
})
export class NotificationsResponsiveComponent {
  private readonly notificationsService: NotificationsService = inject(NotificationsService);

  public notifications = [];
  public hasUnread:boolean = false;
  public notificationsCount: number = 0;
  @Input() currentUser;
  @Output() closeMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  subscribers: Subscription[] = [];

  continuePolling:boolean = true;
  expanded: boolean = false;

  notificationsTooltipText: string = "Toggle notifications";

  constructor(

  ) { }

  ngOnInit() {
    this.subscribers.push(
      this.notificationsService.notifications.subscribe(data => {
        this.notifications = data;
      }),
      this.notificationsService.hasNotifications.subscribe(data => {
        this.hasUnread = data;
        if(this.hasUnread) {
          this.notificationsTooltipText = "You have unread notifications. Toggle notifications";
        } else {
          this.notificationsTooltipText = "Toggle notifications";
        }
      }),
      this.notificationsService.notificationsCount.subscribe(data => {
        this.notificationsCount = data;
      })
    );
  }

  closeMenuEvent(){
    this.closeMenu.emit(true);
  }

  showNotifications() {
    this.expanded = !this.expanded;
    if(this.expanded) {
      this.notificationsService.getUnreadNotifications();
    }
  }

  ngOnDestroy() {
    this.continuePolling = false;
    for(let subscriber of this.subscribers){
      subscriber.unsubscribe();
    }
  }
}
